var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.423,
    height: 23.423,
    viewBox: "0 0 23.423 23.423",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "close_FILL0_wght400_GRAD0_opsz24",
    d: "M221.081-760l2.342,2.342-9.369,9.369,9.369,9.369-2.342,2.342-9.369-9.369-9.369,9.369L200-738.919l9.369-9.369L200-757.658,202.342-760l9.369,9.369Z",
    transform: "translate(-200 760)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.7517107be9cf3f12372b144b8c3b2ceb.svg";
export { ForwardRef as ReactComponent };